/*
Helper to convert object key names in analytics track object to DTM-friendly format

Converts:

track: {
  name: 'MyName',
  type: 'MyType'
}

to:

track: {
  data-track-name: 'MyName',
  data-track-type: 'MyType'
 }
 */

function fixKey(key) {
  // Test whether passed key is for base data-track attribute
  if (key === 'track') {
    return 'data-track';
  }

  return 'data-track-' + key;
}

export const dataTrackMap = (track) => {
  if (!track) return null;

  const fixedTrack = {};
  Object.keys(track).forEach((key) => {
    fixedTrack[fixKey(key)] = track[key];
  });

  return fixedTrack;
}

const ASSET_URL_BASE = 'https://d10dvh97d9q6kg.cloudfront.net';
export const ASSET_URLS = {
  ocLogoUrl: `${ASSET_URL_BASE}/static/images/oc-logo.png`,
  TPRS_LOGO: `${ASSET_URL_BASE}/static/images/warranty/logo/total-protection-system.png`,
  SYSTEM_PROTECTION_LOGO: `${ASSET_URL_BASE}/static/images/warranty/logo/system-protection.png`,
  PREFERRED_PROTECTION_LOGO: `${ASSET_URL_BASE}/static/images/warranty/logo/preferred-protection.png`,
  PLATINUM_PROTECTION_LOGO: `${ASSET_URL_BASE}/static/images/warranty/logo/platinum-protection.png`,
  InfoCircle: `${ASSET_URL_BASE}/static/images/warranty/Info Circle.svg`,
  ArrowIcon: `${ASSET_URL_BASE}/static/images/warranty/Arrow2.svg`,
  DarkArrowIcon: `${ASSET_URL_BASE}/static/images/warranty/Arrow3.svg`,
  PDFIcon: `${ASSET_URL_BASE}/static/images/warranty/PDF.svg`,
  PlusIcon: `${ASSET_URL_BASE}/static/images/warranty/Plus.svg`,
  MinusIcon: `${ASSET_URL_BASE}/static/images/warranty/Minus.svg`,
  TriangleIcon: `${ASSET_URL_BASE}/static/images/warranty/Triangle.svg`,
};
